var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Alert, Button, Modal } from '@cimpress/react-components';
import { ArtworkSelectorWithPreview } from './ArtworkSelectorWithPreview';
import { getItemDetails } from '../apis/item-service';
import { postArtworkChangeRequest } from '../apis/wholesale-aggregation';
import { useAsync } from 'react-async-hook';
import { ProductionEnvironment } from '../environment';
import { useNonDismissibleErrors, useStoredErrors } from '../hooks/useStoredError';
import { StoredErrorComponent } from './StoredErrorComponent';
import { useDoubleTTranslation } from '../hooks/i18n';
var ModalWindows;
(function (ModalWindows) {
    ModalWindows[ModalWindows["ArtworkChangeRequest"] = 0] = "ArtworkChangeRequest";
    ModalWindows[ModalWindows["Success"] = 1] = "Success";
})(ModalWindows || (ModalWindows = {}));
export const ArtworkChangeModal = props => {
    var _a;
    const { modalOpen, onClose, itemId, accessToken, environment } = props;
    const [currentWindow, setCurrentWindow] = React.useState(ModalWindows.ArtworkChangeRequest);
    const { itemServiceBaseUrl, wholesaleAggregationBaseUrl } = environment;
    const [isPosting, setIsPosting] = React.useState(false);
    const [state, setState] = React.useState(undefined);
    const { tt } = useDoubleTTranslation(props.language);
    const [storedErrors, setStoredErrors, catchDismissibleError] = useStoredErrors(3);
    const [catchItemDetailsError, itemServiceRetryCounter] = useNonDismissibleErrors(setStoredErrors, 'item');
    const itemServiceItem = useAsync(() => catchItemDetailsError(getItemDetails(itemServiceBaseUrl, accessToken, itemId)), [accessToken, itemId, itemServiceRetryCounter]);
    const productConfig = (_a = itemServiceItem === null || itemServiceItem === void 0 ? void 0 : itemServiceItem.result) === null || _a === void 0 ? void 0 : _a._links.productConfiguration.href;
    React.useEffect(() => {
        if (!modalOpen) {
            setCurrentWindow(ModalWindows.ArtworkChangeRequest);
        }
    }, [modalOpen]);
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsPosting(true);
        try {
            const { orderId, fulfillmentGroupId } = itemServiceItem.result;
            yield catchDismissibleError(postArtworkChangeRequest(wholesaleAggregationBaseUrl, accessToken, orderId, fulfillmentGroupId, itemId, state));
            setCurrentWindow(ModalWindows.Success);
        }
        finally {
            setIsPosting(false);
        }
    });
    switch (currentWindow) {
        case ModalWindows.Success:
            return React.createElement(Modal, { bsStyle: 'success', closeButton: true, show: modalOpen, onRequestHide: onClose, title: tt('artworkChangeModal.modalTitle'), footer: React.createElement(React.Fragment, null,
                    React.createElement(Button, { className: "btn btn-primary", onClick: onClose }, tt('artworkChangeModal.dismiss'))) },
                React.createElement("div", null,
                    React.createElement(React.Fragment, null, tt('artworkChangeModal.successParagraph1'))),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(Alert, { type: 'info', message: (React.createElement(React.Fragment, null,
                        React.createElement("p", null, tt('artworkChangeModal.successParagraph2')),
                        React.createElement("p", null, tt('artworkChangeModal.successParagraph3')))), dismissible: false }));
        default:
            return React.createElement(Modal, { bsStyle: 'info', closeButton: true, show: modalOpen, onRequestHide: onClose, title: tt('artworkChangeModal.modalTitle'), footer: React.createElement(React.Fragment, null,
                    React.createElement(Button, { className: "btn btn-default", onClick: onClose, disabled: isPosting }, tt('artworkChangeModal.cancel')),
                    React.createElement(Button, { className: "btn btn-primary", onClick: () => handleConfirm(), disabled: isPosting || itemServiceItem.loading || !itemServiceItem.result || !state }, tt('artworkChangeModal.confirm'))) },
                React.createElement(StoredErrorComponent, { storedErrors: storedErrors }),
                React.createElement(ArtworkSelectorWithPreview, Object.assign({}, props, { productConfig: productConfig, oldDocumentReference: (itemServiceItem.result || {}).documentReferenceUrl, mcpSku: (itemServiceItem.result || {}).skuCode, variableAttributes: (itemServiceItem.result || {}).variableAttributes, onChange: setState })));
    }
};
ArtworkChangeModal.defaultProps = {
    environment: ProductionEnvironment
};
//# sourceMappingURL=ArtworkChangeModal.js.map